/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Lot_SaveInputs */

const vi_tea_lot_save = /** @type {(inputs: Tea_Lot_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lưu lô chè`)
};

/**

* @param {Tea_Lot_SaveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_lot_save = /** @type {((inputs?: Tea_Lot_SaveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Lot_SaveInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_lot_save(inputs)
});